import { Button } from '@electricjs/arc';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/constants/routes';
import { ButtonSize } from '@electricjs/arc/components/Button';

type RenewMdmCertButtonProps = {
  buttonSize?: ButtonSize;
};

export const RenewMdmCertButton = ({
  buttonSize = 'large',
}: RenewMdmCertButtonProps) => {
  const { t } = useTranslation('requests');
  const navigate = useNavigate();
  const url = ROUTES.SETTINGS_DEVICE;

  return (
    <Button
      id="renew-mdm-cert-onboarding-button"
      buttonSize={buttonSize}
      onClick={() => navigate(url, { state: { renewCertificate: true } })}>
      {t('taskActions.renewMdmCert.buttonText')}
    </Button>
  );
};

export const RenewMdmCertButtonColumn = () => (
  <RenewMdmCertButton buttonSize="small" />
);
